import { Pipe, PipeTransform } from "@angular/core";
import { CurrencyPipe } from '@angular/common';


@Pipe({
  name: 'customCurrency'
})

export class customCurrencyPipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe) { }

  transform(value: any): string {
    if (value == null || value === '') return '$0.00';

    let numericValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    if (isNaN(numericValue)) return '$0.00';

    if (numericValue < 0) {
      return `(${this.currencyPipe.transform(Math.abs(numericValue))})`;
    }

    return this.currencyPipe.transform(numericValue);
  }

  customCurrencyInput(event): boolean {
    const inputValue = event.target.value;
    const charCode = (event.which) ? event.which : event.keyCode;
    const currentCursorPosition = event.target.selectionStart;
    if (charCode == 46 && inputValue.includes('.') && inputValue.indexOf('.') !== currentCursorPosition) {
      return false;
    }
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode === 47)) {
      return false;
    }
    return true;
  }
}
